var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "edit",
    d: "M15.765,18H2.265a2.168,2.168,0,0,1-1.591-.66,2.167,2.167,0,0,1-.659-1.593V2.234A2.143,2.143,0,0,1,.674.65,2.181,2.181,0,0,1,2.265,0H12.39L10.14,2.233H3.39a1.073,1.073,0,0,0-.8.334,1.1,1.1,0,0,0-.325.792V14.62a1.075,1.075,0,0,0,.334.8,1.094,1.094,0,0,0,.791.326H14.64a1.112,1.112,0,0,0,1.125-1.126V7.865l2.25-2.252V15.747A2.252,2.252,0,0,1,15.765,18ZM5.64,9.835l2.532,2.534L4.515,13.495ZM9.3,11.524l-2.813-2.8L14.9.281a1.04,1.04,0,0,1,1.423,0l1.389,1.408a.976.976,0,0,1,.29.695.941.941,0,0,1-.29.712Z",
    transform: "translate(-0.015 0.001)",
    fill: "#74613c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.8649647956dae0eaaaed75161f9d9100.svg";
export { ForwardRef as ReactComponent };